import { Route, Routes } from 'react-router-dom';

import VocabulariesPage from './vocabularies-page';
import VocabularyPage from './vocabulary-page';

export default function VocabulariesRouter() {
    return (
        <Routes>
            <Route
                path="/"
                element={<VocabulariesPage />}
            />

            <Route
                path="/:id"
                element={<VocabularyPage />}
            />
        </Routes>
    );
}